import clsx from 'clsx'

import mainStyles from 'assets/css/main.module.scss'
import { ReactComponent as ArrowRight } from 'assets/icons/arrow-right.svg'
import { ReactComponent as MailIcon } from 'assets/icons/mail.svg'
import starImage from 'assets/images/practitioner/stars.png'
import Bubble from 'components/bubble/Bubble'
import { Button } from 'components/common/button/Button'
import TruncatedText from 'components/truncatedText/TruncatedText'
import Avatar from 'components/uikit/Avatar'
import { Icon } from 'components/uikit/Icon/Icon'
import { AnalyticsActionType } from 'types/analytics.type'
import { ANALYTICS_EVENTS, trackAnalytics } from 'utils/analytics'

import styles from './PracticionerCard.module.scss'

interface Props {
  name: string
  communityTag: string
  associatedRole?: string
  cluster: string
  userId?: string
  email?: string
  showBubble?: boolean
  showStar?: boolean
  image?: string
  className?: string
}

const PracticionerCard = ({
  name,
  communityTag,
  associatedRole,
  cluster,
  email,
  showBubble,
  showStar,
  image,
  className,
}: Props) => {
  return (
    <div className={clsx(styles.cardWrapper, className)}>
      <div className={clsx(styles.card)}>
        <div className={styles.profileImageWrapper}>
          <div className={styles.profileImage}>
            {showBubble && (
              <Bubble
                text="Ellooooo"
                color="#EBFF00"
                className={styles.bubble}
                fontClassName="italic font-bold text-[#282828]"
              />
            )}
            {showStar && <img src={starImage} alt="star" className={styles.star} />}
            {image ? (
              <img src={image} alt="profile-img" className={clsx('w-full', styles.avatarImage)} />
            ) : (
              <>
                <Avatar name={name} size="2xl" variant="square" className={styles.avatar} />
              </>
            )}
          </div>
        </div>
        <div className={styles.profileContent}>
          <div className={styles.nameHeading}>
            <span>{name}</span>
          </div>
          <div className={clsx(styles.communityTag)}>
            <TruncatedText text={communityTag} maxWidth="150px" />
          </div>
          <div className={styles.role}>
            <TruncatedText text={associatedRole} maxWidth="150px" />
          </div>
          <div className={clsx(styles.cluster, mainStyles.textTruncate)}>
            <TruncatedText text={cluster} maxWidth="150px" />
          </div>
          <div className={styles.btnVisitExpProfileWrapper}>
            <Button
              variant="outlined"
              className={clsx(styles.btnVisitExpProfile, 'transition-all min-w-fit')}
              text="Visit Experience profile"
              iconRight={<Icon icon={ArrowRight} color="white" />}
              onClick={() => {
                trackAnalytics({
                  type: AnalyticsActionType.action,
                  payload: ANALYTICS_EVENTS.PRACTITIONERS_CARD_VISIT_EXPERIENCE_PROFILE_CLICKED(name),
                })
                window.open(`${process.env.REACT_APP_EXPERIENCE_PROFILE_BASE_URL}/users/${email}/public`)
              }}
            />
          </div>
        </div>
        <div className={styles.mailIcon}>
          <a
            href={`mailto:${email}`}
            onClick={() =>
              trackAnalytics({
                type: AnalyticsActionType.action,
                payload: ANALYTICS_EVENTS.PRACTITIONERS_CARD_VISIT_EXPERIENCE_PROFILE_CLICKED(name),
              })
            }
          >
            <Icon icon={MailIcon} color="#F4F4F4" />
          </a>
        </div>
      </div>
    </div>
  )
}

export default PracticionerCard
